<template>
  <div
    :class="[
      $style.status,
      color && $style[`status-${color}`],
      size && $style[`status-${size}`],
      disabled && $style.disabled,
    ]"
    ref="status"
    :aria-disabled="disabled"
  >
    <b-svg
      v-if="icon"
      :name="icon"
      :class="$style.icon"
    />
    <slot name="default" />
  </div>
</template>

<script>
const COLORS = {
  ORANGE: 'orange',
  RED: 'red',
  GREEN: 'green',
  GRAY: 'gray',
  TEAL: 'teal',
  VIOLET: 'violet',
  BLACK: 'black',
}

const SIZES = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
}

export default {
  name: 'b-status',
  props: {
    color: {
      type: String,
      default: null,
      validator: v => Object.values(COLORS).includes(v),
    },
    size: {
      type: String,
      default: null,
      validator: s => Object.values(SIZES).includes(s),
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
}
</script>

<style lang="scss" module>
@layer legacy-views {

.status {
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 var(--b-gap-2);
  height: var(--b-gap-6);
  border-radius: var(--b-border-radius-xl);
  font-size: var(--b-font-size-h6);
  text-transform: uppercase;
  user-select: none;
  font-weight: var(--b-font-weight-medium);
  letter-spacing: .03em;
  vertical-align: bottom;

  color: var(--b-color-primary);
  background-color: var(--b-color-bg-secondary);

  &.disabled {
    color: var(--b-color-disabled);
    background-color: var(--b-color-bg-disabled);
  }
}

@each $color in ('orange', 'red', 'green', 'gray', 'teal', 'violet') {
  .status-#{$color} {
    color: var(--b-color-#{$color}-lt-fg);
    background-color: var(--b-color-#{$color}-lt);
  }
}

.status-black {
  color: var(--b-color-white);
  background-color: var(--b-color-black);
}

.status-sm {
  height: var(--b-gap-4);
  font-size: var(--b-font-size-h7);
  letter-spacing: .07em;
}

.status-lg {
  height: var(--b-gap-7);
  padding: 0 var(--b-gap-3);
}

.icon {
  width: 1rem !important;
  height: 1rem !important;
  margin-right: var(--b-gap-1);
}

}</style>
